import {createSlice} from '@reduxjs/toolkit'

const darkSlice=createSlice({
    name:'darkmode',
    initialState:{
        darkmode: false,
        status:null
    },
    reducers:{
    }
})
export default darkSlice.reducer
export const {}=darkSlice.actions